/**
 * Sets file state to initial
 * @param setFileState
 */
export function removeFile(setFileState) {
    setFileState((state) => ({
        ...state, ...{
            filename: '', file: ''
        }
    }))
}

/**
 *  Adds file to file state
 * @param {event} event
 * @param {file[]} files
 * @param {function} setFileState
 */
export function addFile(event, files, setFileState, types) {
    const file = files[0];
    const fileName = file.name.toLowerCase();
    
    // Check if file type is accepted
    const isAccepted = types.some(type => {
        if (type.startsWith('image/')) {
            // For MIME types, check file.type
            return file.type === type;
        } else {
            // For extensions, check filename
            return fileName.endsWith(type.toLowerCase());
        }
    });
    
    if (isAccepted) {
        const filename = file.name;
        setFileState((state) => ({ ...state, ...{ filename, file } }))
    } else {
        console.warn('File type not accepted:', file.type, file.name);
    }
}
